import ActionTypes from '../common/ActionTypes';
import Strings from '../common/Strings';
import Constant from '../common/Constant';

const moment = require('moment');

const timers = [];

function showNotification() {
  const notification = {
    title: Strings.COMMON.notificationTitle,
    options: {
      tag: `tag${Date.now()}`,
      body: Strings.COMMON.notificationBody,
      requireInteraction: true,
    },
  };

  return {
    type: ActionTypes.SHOW_NOTIFICATION,
    notification,
  };
}

function cancelAllNotifications() {
  return () => {
    timers.forEach(timerId => {
      clearTimeout(timerId);
    });
    timers.length = 0;
  };
}

function schedule(date, now) {
  return dispatch => {
    const timeout = date.diff(now, 'milliseconds');
    if (timeout > 0) {
      timers.push(
        setTimeout(() => {
          dispatch(showNotification());
        }, timeout),
      );
    }
  };
}

function scheduleHourly(settings, now, hourIncrease) {
  return dispatch => {
    const startParts = settings.alertStartingAt.split(':');
    const start = moment(now);
    start.set('millisecond', 0);
    start.set('second', 0);
    start.set('minutes', startParts[1]);
    start.set('hours', startParts[0]);

    const endParts = settings.alertEndingAt.split(':');
    const end = moment(now);
    end.set('millisecond', 0);
    end.set('second', 0);
    end.set('minutes', endParts[1]);
    end.set('hours', endParts[0]);

    while (end.diff(start, 'hours') > hourIncrease) {
      start.add('hours', hourIncrease);
      dispatch(schedule(start, now));
    }
    dispatch(schedule(end, now));
  };
}

function scheduleTwicePerDay(settings, now) {
  return dispatch => {
    const startParts = settings.alertStartingAt.split(':');
    const start = moment(now);
    start.set('millisecond', 0);
    start.set('second', 0);
    start.set('minutes', startParts[1]);
    start.set('hours', startParts[0]);

    const endParts = settings.alertEndingAt.split(':');
    const end = moment(now);
    end.set('millisecond', 0);
    end.set('second', 0);
    end.set('minutes', endParts[1]);
    end.set('hours', endParts[0]);

    start.add(end.diff(start) / 2);

    dispatch(schedule(start, now));
    dispatch(schedule(end, now));
  };
}

function scheduleEndOfDay(settings, now) {
  return dispatch => {
    const parts = settings.alertEndingAt.split(':');
    const date = moment();
    date.set('millisecond', 0);
    date.set('second', 0);
    date.set('minutes', parts[1]);
    date.set('hours', parts[0]);

    dispatch(schedule(date, now));
  };
}

function scheduleNotifications(user) {
  return dispatch => {
    dispatch(cancelAllNotifications());

    const { settings, timer } = user;
    if (settings.alertEnabled && Constant.TIMER_RUNNING !== timer.status) {
      const date = moment();
      const day = date.day();

      if (
        settings.alertPausedDate === date.format(Constant.DATE_FORMAT_SHORT)
      ) {
        return;
      }

      if (settings.alertDays.find(d => d === day)) {
        if (settings.alertInterval === Constant.ALERT_INTERVAL_HOURLY) {
          dispatch(scheduleHourly(settings, date, 1));
        } else if (
          settings.alertInterval === Constant.ALERT_INTERVAL_BI_HOURLY
        ) {
          dispatch(scheduleHourly(settings, date, 2));
        } else if (
          settings.alertInterval === Constant.ALERT_INTERVAL_TWICE_PER_DAY
        ) {
          dispatch(scheduleTwicePerDay(settings, date));
        } else if (
          settings.alertInterval === Constant.ALERT_INTERVAL_END_OF_DAY
        ) {
          dispatch(scheduleEndOfDay(settings, date));
        }
      }
    }
  };
}

export const notificationActions = {
  scheduleNotifications,
  cancelAllNotifications,
};



// WEBPACK FOOTER //
// ./src/actions/notification.js